// extracted by mini-css-extract-plugin
module.exports = {"root":"SubHeader_root__1WHNN","container":"SubHeader_container__34V9O"};